import { memo } from 'react';

import { Form, Input } from 'antd';

import { EyeInvisibleOutlined, EyeTwoTone, LockFilled } from '@ant-design/icons';

import { PASSWORD_PLACEHOLDER } from '../constants/common';

function PasswordField({ label = 'Password', disabled = false, dependencies, name, rules, onInputChange }) {
  return (
    <Form.Item dependencies={dependencies} label={label} name={name} colon={false} rules={rules}>
      <Input.Password
        disabled={disabled}
        size="large"
        addonBefore={<LockFilled />}
        placeholder={PASSWORD_PLACEHOLDER}
        iconRender={visible => (visible ? <EyeTwoTone /> : <EyeInvisibleOutlined />)}
        onChange={onInputChange}
      />
    </Form.Item>
  );
}

export default memo(PasswordField);
